import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const menuItems = [
    { label: "Front Page", path: "/" },
    { label: "The Wines", path: "/the-wines" },
    { label: "The Cocktails", path: "/the-cocktails" },
    { label: "The Family", path: "/the-family" },
    { label: "Visit Us", path: "/visit-us" }
  ];

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <header className="sticky top-0 z-50 border-b border-wine-900/60 bg-wine-950/95 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 group py-2">
          <img
            src="https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=95,format=auto/assets/5ea68c18-23db-4ec0-b08f-b9fe5fda53ae/66995ea1-67a0-4d2a-86bd-857f23dff781.png"
            alt="La Fable Logo"
            className="h-14 sm:h-16 md:h-18 w-auto object-contain transition-all duration-500 group-hover:scale-105 filter drop-shadow-[0_4px_12px_rgba(0,0,0,0.5)]"
          />
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden xl:flex items-center gap-8">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`relative py-2 font-display text-[11px] uppercase tracking-[0.18em] font-medium transition-all duration-300 hover:text-white group ${
                isActive(item.path) ? 'text-sand-300 font-semibold' : 'text-sand-100/70'
              }`}
            >
              {item.label}
              {/* Hover-streg animation samt aktiv streg */}
              <span className={`absolute bottom-0 left-0 h-[1px] bg-sand-300 transition-all duration-300 origin-left ${
                isActive(item.path) ? 'w-full scale-x-100' : 'w-full scale-x-0 group-hover:scale-x-100'
              }`} />
            </Link>
          ))}
        </nav>

        {/* Mobile Menu Button */}
        <div className="flex xl:hidden items-center gap-4">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="text-sand-100 hover:text-sand-300 focus:outline-none p-2"
            aria-label="Toggle menu"
          >
            <i className={`fa-solid ${isOpen ? 'fa-xmark' : 'fa-bars'} text-xl`} />
          </button>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {isOpen && (
        <div className="xl:hidden border-t border-wine-900/40 bg-wine-950/98 backdrop-blur-lg">
          <div className="space-y-1 px-4 py-6 sm:px-6">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsOpen(false)}
                className={`block rounded-none px-4 py-3 font-display text-xs uppercase tracking-[0.15em] font-light transition-colors ${
                  isActive(item.path)
                    ? 'bg-wine-900/40 text-sand-300 border-l border-sand-300'
                    : 'text-sand-200/80 hover:bg-wine-900/20 hover:text-sand-300'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
